import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const JIS2_BOARD_PARENT_ISSUE_FIELD_FRAGMENT = gqlTagGira`
    fragment JIS2_BoardParentIssueFieldFragment on JiraWorkManagementViewItem {
        issueId
        fieldsByIdOrAlias(idsOrAliases: $fieldIds, ignoreMissingFields: true) {
          ... on JiraParentIssueField {
            fieldId
            parentIssue {
              issueId
            }
          }
          ... on JiraSingleLineTextField {
            fieldId
            text
          }
          ... on JiraSingleSelectUserPickerField {
            fieldId
            user {
              ... on AtlassianAccountUser {
                accountId
                name
                picture
              }
            }
          }
          ... on JiraIssueTypeField {
            fieldId
            id
            name
            issueType {
              issueTypeId
              name
              avatarId
              avatar {
                medium
              }
            }
          }
          ... on JiraStatusField {
            fieldId
            status {
              name
              statusId
              statusCategory {
                statusCategoryId
              }
            }
          }
          ... on JiraPriorityField {
            fieldId
            priority {
              name
              iconUrl
            }
          }
        }
    }
`;

export const JIS2_BOARD_PARENT_ISSUE_QUERY = gqlTagGira`
    query JIS2_JiraBusinessBoardSubtaskItems ($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int) {
      subtaskIssues: jira {
        jwmViewItems(
          cloudId: $cloudId
          jql: $jql
          first: $first
        ) {
          ... on QueryError {
            message
            extensions {
              statusCode
              errorType
            }
          }
          ... on JiraWorkManagementViewItemConnection {
            edges {
                node {
                    ...JIS2_BoardParentIssueFieldFragment
                }
            }
          }
        }
      }
    }
    ${JIS2_BOARD_PARENT_ISSUE_FIELD_FRAGMENT}
`;
